import React from 'react'

import { GameWithUserInformation } from 'containers/GamesBlock/types'

import { BadgesBox, BadgesContainer } from './styles'
import { useBadges } from './useBadges'

interface Props {
  game: GameWithUserInformation
}

export function Badges({ game }: Props) {
  const badges = useBadges(game)

  if (badges.length === 0) {
    return null
  }

  return (
    <BadgesContainer>
      <BadgesBox>
        {badges.map((Badge, index) => (
          <Badge key={index} />
        ))}
      </BadgesBox>
    </BadgesContainer>
  )
}
